import { Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoBar from "@pages/Contents/BadgeAndCertificates/components/bars/InfoBar";
import BasicTabs from "@pages/Contents/BadgeAndCertificates/components/BasicTabs";
import React from "react";
import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import ButtonBackPage from "@components/ButtonBackPage";

const ManageRequests = () => {
  const { t } = useTranslation(["skillBook-page"]);
  const { userId } = useParams();
  const location = useLocation();
  const { state } = location;
  const name = state?.name;

  const [requestCounts, setRequestCounts] = useState({
    totalReqs: 0,
    approvedReqs: 0,
    waitingReqs: 0,
    rejectedReqs: 0,
  });

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-skillbook-form.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={
            userId ? `${t("manage_requests")} - ${name}` : t("manage_requests")
          }
          description={t("add.hero-description")}
        />
        <ButtonBackPage customRedirect={-1} />
        <Grid container>
          <InfoBar
            totalReqs={requestCounts.totalReqs}
            approvedReqs={requestCounts.approvedReqs}
            waitingReqs={requestCounts.waitingReqs}
            rejectedReqs={requestCounts.rejectedReqs}
          />

          <BasicTabs
            approvedReqs={requestCounts.approvedReqs}
            waitingReqs={requestCounts.waitingReqs}
            rejectedReqs={requestCounts.rejectedReqs}
            setRequestCounts={setRequestCounts}
          />
        </Grid>
      </Container>
    </AnimationFadeIn>
  );
};

export default ManageRequests;
